/**
 * Performance configuration constants
 * Used for tracking and displaying slow loading indicators
 */

/**
 * Threshold in milliseconds for showing "Still loading..." hints
 * When a planner store request takes longer than this threshold,
 * a subtle loading indicator will be shown to the user
 * 
 * Default: 1000ms (1 second)
 * Can be adjusted based on typical network conditions
 */
export const SLOW_LOADING_THRESHOLD_MS = 1000;
